import { HStack, Image, Text } from "@chakra-ui/react";
import { profileIcon } from "assets/images";
import { getSession } from "features/auth/slice";
import React from "react";
import { useAppSelector } from "tools/store";
import CustomeDrawer from "./CustomeDrawer";

const CustomHeader: React.FC = () => {
  const userData = useAppSelector(getSession);

  return (
    <HStack w={"full"} justify={"space-between"} py={2}>
      {/* <TouchableOpacity onClick={() => { }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="25.987" height="26" viewBox="0 0 25.987 26">
                    <g id="Group_7263" data-name="Group 7263" transform="translate(-328 -50)">
                        <path id="Vector" d="M18.447,0H7.553C2.821,0,0,2.821,0,7.553V18.434C0,23.179,2.821,26,7.553,26H18.434c4.732,0,7.553-2.821,7.553-7.553V7.553C26,2.821,23.179,0,18.447,0Z" transform="translate(328 50)" fill="#ecdfc9" />
                        <path id="Vector-2" data-name="Vector" d="M13.975,1.95h-13A.982.982,0,0,1,0,.975.982.982,0,0,1,.975,0h13a.982.982,0,0,1,.975.975A.982.982,0,0,1,13.975,1.95Z" transform="translate(333.525 56.175)" fill="#bf8d46" />
                        <path id="Vector-3" data-name="Vector" d="M13.975,1.95h-13A.982.982,0,0,1,0,.975.982.982,0,0,1,.975,0h13a.982.982,0,0,1,.975.975A.982.982,0,0,1,13.975,1.95Z" transform="translate(333.525 62.025)" fill="#bf8d46" />
                        <path id="Vector-4" data-name="Vector" d="M13.975,1.95h-13A.982.982,0,0,1,0,.975.982.982,0,0,1,.975,0h13a.982.982,0,0,1,.975.975A.982.982,0,0,1,13.975,1.95Z" transform="translate(333.525 67.875)" fill="#bf8d46" />
                    </g>
                </svg>
            </TouchableOpacity> */}

      <CustomeDrawer />

      <HStack>
        {userData?.user && (
          <Text fontSize={"3xl"} fontWeight={"bold"} px={4}>
            {userData?.user?.fname}
          </Text>
        )}
        <Image src={profileIcon} h={"45px"} />
      </HStack>
    </HStack>
  );
};

export default CustomHeader;
